// IMAGES
import Icon from '../../assets/roulette-selector.png';
var rouletteSelector = new Image();
rouletteSelector.src = Icon;
export { rouletteSelector };
